export const projectOfficeRouter = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '数据统计',
    },
    component: () => import('../views/projectOffice/page/index'),
  },
  {
    path: 'notice',
    meta: {
      title: '通知列表',
    },
    component: () => import('../views/projectOffice/page/notice'),
  },
  {
    path: 'noticeDetail',
    meta: {
      title: '通知详情',
    },
    component: () => import('../views/projectOffice/page/noticeDetail'),
  },
  {
    path: 'noticeAdd',
    meta: {
      title: '通知编辑',
    },
    component: () => import('../views/projectOffice/page/noticeAdd'),
  },
  {
    path: 'organization',
    meta: {
      title: '机构列表',
    },
    component: () => import('../views/projectOffice/page/organization'),
  },
  {
    path: 'organizationDetail2',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/organizationDetail2'),
  },
  {
    path: 'organizationDetail3',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/organizationDetail3'),
  },
  {
    path: 'organizationDetail4',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/organizationDetail4'),
  },
  {
    path: 'organizationDetail5',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/organizationDetail5'),
  },
  {
    path: 'organizationDetail6',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/organizationDetail6'),
  },
  {
    path: 'orgShenheDetail2',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/orgShenheDetail2'),
  },
  {
    path: 'orgShenheDetail3',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/orgShenheDetail3'),
  },
  {
    path: 'orgShenheDetail4',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/orgShenheDetail4'),
  },
  {
    path: 'orgShenheDetail5',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/orgShenheDetail5'),
  },
  {
    path: 'orgShenheDetail6',
    meta: {
      title: '机构详情',
    },
    component: () => import('../views/projectOffice/page/orgShenheDetail6'),
  },
  {
    path: 'complaint',
    meta: {
      title: '投诉明细',
    },
    component: () => import('../views/projectOffice/page/complaint'),
  },
  {
    path: 'organizationAdd2',
    meta: {
      title: '机构编辑',
    },
    component: () => import('../views/projectOffice/page/organizationAdd2'),
  },
  {
    path: 'organizationAdd3',
    meta: {
      title: '机构编辑',
    },
    component: () => import('../views/projectOffice/page/organizationAdd3'),
  },
  {
    path: 'organizationAdd4',
    meta: {
      title: '机构编辑',
    },
    component: () => import('../views/projectOffice/page/organizationAdd4'),
  },
  {
    path: 'organizationAdd5',
    meta: {
      title: '机构编辑',
    },
    component: () => import('../views/projectOffice/page/organizationAdd5'),
  },
  {
    path: 'organizationAdd6',
    meta: {
      title: '机构编辑',
    },
    component: () => import('../views/projectOffice/page/organizationAdd6'),
  },
  {
    path: 'regulators',
    meta: {
      title: '机构审核',
    },
    component: () => import('../views/projectOffice/page/regulators'),
  },
  {
    path: 'annualReview',
    meta: {
      title: '年审提醒',
    },
    component: () => import('../views/projectOffice/page/annualReview'),
  },
  {
    path: 'account',
    meta: {
      title: '帐号管理',
    },
    component: () => import('../views/projectOffice/page/account'),
  },
  {
    path: 'examination',
    meta: {
      title: '考试管理',
    },
    component: () => import('../views/projectOffice/page/examination'),
  },
  {
    path: 'examEdit',
    meta: {
      title: '考试编辑',
    },
    component: () => import('../views/projectOffice/page/examEdit'),
  },
  {
    path: 'firstSubjects',
    meta: {
      title: '一级科目',
    },
    component: () => import('../views/projectOffice/page/firstSubjects'),
  },
  {
    path: 'secondSubjects',
    meta: {
      title: '二级科目',
    },
    component: () => import('../views/projectOffice/page/secondSubjects'),
  },
  {
    path: 'signup',
    meta: {
      title: '报名表管理',
    },
    component: () => import('../views/projectOffice/page/signup'),
  },
  {
    path: 'signupEdit',
    meta: {
      title: '报名表编辑',
    },
    component: () => import('../views/projectOffice/page/signupEdit'),
  },
  {
    path: 'basics',
    meta: {
      title: '基础知识',
    },
    component: () => import('../views/projectOffice/page/basics'),
  },
  {
    path: 'basicsExam',
    meta: {
      title: '基础知识',
    },
    component: () => import('../views/projectOffice/page/basicsExam'),
  },
  {
    path: 'case',
    meta: {
      title: '实践案例',
    },
    component: () => import('../views/projectOffice/page/case'),
  },
  {
    path: 'caseExam',
    meta: {
      title: '实践案例',
    },
    component: () => import('../views/projectOffice/page/caseExam'),
  },
  {
    path: 'explain',
    meta: {
      title: '考试说明',
    },
    component: () => import('../views/projectOffice/page/explain'),
  },
  {
    path: 'score',
    meta: {
      title: '评分表管理',
    },
    component: () => import('../views/projectOffice/page/score'),
  },
  {
    path: 'scoreEdit',
    meta: {
      title: '评分表编辑',
    },
    component: () => import('../views/projectOffice/page/scoreEdit'),
  },
  {
    path: 'scoreItem',
    meta: {
      title: '设置评分值',
    },
    component: () => import('../views/projectOffice/page/scoreItem'),
  },
  {
    path: 'examiner',
    meta: {
      title: '考官管理',
    },
    component: () => import('../views/projectOffice/page/examiner'),
  },
  {
    path: 'examCenter',
    meta: {
      title: '考场',
    },
    component: () => import('../views/projectOffice/page/examCenter'),
  },
  {
    path: 'examStudent',
    meta: {
      title: '学生列表',
    },
    component: () => import('../views/projectOffice/page/examStudent'),
  },
  {
    path: 'examStudentDetail',
    meta: {
      title: '学生详情',
    },
    component: () => import('../views/projectOffice/page/examStudentDetail'),
  },
  {
    path: 'examInvite',
    meta: {
      title: '邀请报名',
    },
    component: () => import('../views/projectOffice/page/examInvite'),
  },
  {
    path: 'examPaper',
    meta: {
      title: '试卷列表',
    },
    component: () => import('../views/projectOffice/page/examPaper'),
  },
  {
    path: 'basicPaperDialog',
    meta: {
      title: '基础知识试卷',
    },
    component: () => import('../views/projectOffice/page/basicPaperDialog'),
  },
  {
    path: 'casePaperDialog',
    meta: {
      title: '实践案例试卷',
    },
    component: () => import('../views/projectOffice/page/casePaperDialog'),
  },
  {
    path: 'examSgin',
    meta: {
      title: '签到列表',
    },
    component: () => import('../views/projectOffice/page/examSgin'),
  },
  {
    path: 'examSginDetail',
    meta: {
      title: '签到详情',
    },
    component: () => import('../views/projectOffice/page/examSginDetail'),
  },
  {
    path: 'examStatistics',
    meta: {
      title: '分数统计',
    },
    component: () => import('../views/projectOffice/page/examStatistics'),
  },
  {
    path: 'examBasicStatistics',
    meta: {
      title: '基础得分统计',
    },
    component: () => import('../views/projectOffice/page/examBasicStatistics'),
  },
  {
    path: 'examCaseStatistics',
    meta: {
      title: '案例得分统计',
    },
    component: () => import('../views/projectOffice/page/examCaseStatistics'),
  },
  {
    path: 'examOrder',
    meta: {
      title: '订单对比',
    },
    component: () => import('../views/projectOffice/page/examOrder'),
  },
  {
    path: 'order',
    meta: {
      title: '订单管理',
    },
    component: () => import('../views/projectOffice/page/order'),
  },
  {
    path: 'record',
    meta: {
      title: '证书发放记录',
    },
    component: () => import('../views/projectOffice/page/record'),
  },
  {
    path: 'recordDetail',
    meta: {
      title: '证书发放记录详情',
    },
    component: () => import('../views/projectOffice/page/recordDetail'),
  },
  {
    path: 'guidance',
    meta: {
      title: '指导师证管理',
    },
    component: () => import('../views/projectOffice/page/guidance'),
  },
  {
    path: 'teacher',
    meta: {
      title: '教师证管理',
    },
    component: () => import('../views/projectOffice/page/teacher'),
  },
  {
    path: 'invoice',
    meta: {
      title: '发票申请',
    },
    component: () => import('../views/projectOffice/page/invoice'),
  },
  {
    path: 'delay',
    meta: {
      title: '延期申请',
    },
    component: () => import('../views/projectOffice/page/delay'),
  },
  {
    path: 'teacherList',
    meta: {
      title: '教师列表',
    },
    component: () => import('../views/projectOffice/page/teacherList'),
  },
  {
    path: 'userInfo',
    meta: {
      title: '个人中心',
    },
    component: () => import('../views/projectOffice/page/userInfo'),
  }

]